import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import ProductCard from "../../components/products/ProductCard";
import { useSelector, useDispatch } from "react-redux";
import firebase from "firebase/app";
import { Typography } from "@mui/material";
import { setFavouriteProducts } from "../../redux/reducers/favouriteProducts.reducer";
import FullScreenLoading from "../../components/FullScreenLoading";
import EmptyComponentRender from "../../components/EmptyComponentRender";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
const Favorites = () => {
  const currentUser = firebase.auth().currentUser;
  const dispatch = useDispatch();
  const userFavProducts = useSelector(
    (state) => state.favouriteProducts.products
  );
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getFavProducts();
  }, [userFavProducts])

  const getFavProducts = async () => {
    setLoading(true);
    let arr = [];
    await firebase
      .firestore()
      .collection("products")
      .get()
      .then((result) => {
        result.docs.filter((r) => {
          if (userFavProducts?.includes(r.id)) {
            arr.push(r.data());
          }
        })
      }).catch((err) => {
        console.log("err:", err)
        setLoading(false);
      })
    setProducts(arr);
    setLoading(false);
  }

  const handleFavouriteChange = async (id) => {
    let favList = userFavProducts.filter(productId => productId != id) ?? [];
    dispatch(setFavouriteProducts(favList));
    await firebase.firestore().collection("users").doc(currentUser.uid).set({ favourites: favList }, { merge: true })
  }


  if (loading) {
    return <FullScreenLoading />
  }

  return (
    <Container style={{ paddingTop: isMobile ? 60 : 0 }} >
      <Typography style={{ color: "rgb(119, 78, 30)", fontSize: "35px", textAlign: "center", marginBottom: "40px", fontWeight: "bold" }}>{t("screens.favourite")}</Typography>
      {products && products.length > 0 ? <Grid containter spacing={12}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Grid container spacing={12}>
            {products.map((item) => (
              <ProductCard card={item} key={item.id} handleChange={handleFavouriteChange} />
            ))}
          </Grid>
        </div>
      </Grid> :
        <Grid item xs={12} sm={12} style={{ marginTop: "30%" }}>
          <EmptyComponentRender />
        </Grid>
      }
    </Container>
  )
}

export default Favorites;